export default "__VITE_ASSET__c134716c__"